import { calculateAgeFromBirthDate } from '../config/agePolicy';

/** Parents must be adults; matches signup age gate for parent accounts. */
export const PARENT_ACCOUNT_MIN_AGE = 18;

export function isParentProfileDobLocked(
  profile: {
    stripe_identity_status?: string | null;
    stripe_identity_verified_at?: string | null;
  } | null
): boolean {
  return Boolean(
    profile?.stripe_identity_status === 'verified' && profile?.stripe_identity_verified_at
  );
}

export function validateParentDateOfBirth(
  dateOfBirth: string
): { ok: true } | { ok: false; message: string } {
  const trimmed = String(dateOfBirth || '').trim();
  if (!trimmed) {
    return { ok: false, message: 'Date of birth is required.' };
  }

  const age = calculateAgeFromBirthDate(trimmed);
  if (age == null) {
    return { ok: false, message: 'Enter a valid date of birth.' };
  }

  if (age < PARENT_ACCOUNT_MIN_AGE) {
    return {
      ok: false,
      message: `You must be at least ${PARENT_ACCOUNT_MIN_AGE} years old.`,
    };
  }

  return { ok: true };
}
